import { fetchApi } from '@/services/api-client';

/** Mirrors `risp-api/src/modules/my-dashboard/my-dashboard.dto.ts`. */
export const MY_DASHBOARD_ACTION_KINDS = [
  'it-assigned',
  'it-unassigned',
  'mss-days-to-mark',
  'mss-decision-unseen',
  'mss-proposed',
  'edp-proposal-returned',
  'incident-unread',
  'suspension-unread',
  'register-missing',
  'edp-register-missing',
  'report-card-outstanding',
  'newsletter-slot-missing',
  'sparky-attention-open',
  'sparky-lesson-running',
  'sparky-lesson-draft',
  'leave-pending',
  'allergy-change-pending',
  'contact-inquiry-new',
  'tour-request-new',
  'trial-ending',
  'edp-proposal-submitted',
  'edp-payment-declared',
  'tuition-payment-declared',
  'receipt-copy-requested',
  'parent-profile-change',
  'teacher-profile-change',
] as const;
export type MyDashboardActionKind = (typeof MY_DASHBOARD_ACTION_KINDS)[number];

export const MY_DASHBOARD_ACTION_GROUPS = ['assigned', 'teaching', 'queue'] as const;
export type MyDashboardActionGroup = (typeof MY_DASHBOARD_ACTION_GROUPS)[number];

export type MyDashboardRegisterGap = {
  /** YYYY-MM-DD, school calendar day. */
  date: string;
  /** The class; for an EDP register, the course. */
  className: string;
  gradeLevel: number | null;
  /** Null for an EDP register. */
  subjectName: string | null;
  /** The period; for an EDP register, the block. */
  periodName: string;
  state: 'missing' | 'partial';
  href: string;
};

export type MyDashboardAction = {
  kind: MyDashboardActionKind;
  group: MyDashboardActionGroup;
  count: number;
  oldestAt: string | null;
  dueAt: string | null;
  overdue: boolean;
  href: string;
  /** Only for `register-missing` / `edp-register-missing`. */
  registers?: MyDashboardRegisterGap[];
};

export type MyDashboardTodayKind = 'birthdays' | 'colleague-out' | 'my-document-expiring';

export type MyDashboardBirthdayStudent = { id: string; displayName: string; gradeLevel: number };

export type MyDashboardColleagueOut = { userId: string; name: string; periods: string[] };

export type MyDashboardExpiringDocument = {
  type: 'visa' | 'workPermit' | 'ninetyDayReport';
  /** The server's English wording; the admin localises by `type` instead. */
  label: string;
  /** YYYY-MM-DD. */
  expiresOn: string;
  /** Negative once overdue. */
  daysRemaining: number;
};

export type MyDashboardTodayItem = {
  kind: MyDashboardTodayKind;
  students?: MyDashboardBirthdayStudent[];
  colleagues?: MyDashboardColleagueOut[];
  documents?: MyDashboardExpiringDocument[];
};

export type MyDashboard = {
  actions: MyDashboardAction[];
  today: MyDashboardTodayItem[];
};

export const myDashboardApi = {
  get: () => fetchApi<MyDashboard>('/me/dashboard'),
};
